export const MUT_GET_CONNECTED = 'MUT_GET_CONNECTED';
export const MUT_SET_CONNECTED = 'MUT_SET_CONNECTED';
export const MUT_SET_ADDRESSES = 'MUT_GET_ADDRESSES';
export const MUT_GET_ADDRESSES = 'MUT_GET_ADDRESSES';
export const MUT_SET_WEB3 = 'MUT_SET_WEB3';
export const MUT_SET_NETWORK_ID = 'MUT_SET_NETWORK_ID';
